export default "__VITE_ASSET__1jHlMrO9__"